/*
 * View for handling the refresh of the kb on the server and displaying the
 * last refresh time
 */

define([
  "marionette",
  "modules/header/kbRefreshMenu/template/kbRefreshMenuTemplate.html",
], function (Marionette, KbRefreshMenuTemplate) {
  var KbRefreshMenuView = {};

  KbRefreshMenuView.kbRefreshMenuView = Marionette.ItemView.extend({
    template: KbRefreshMenuTemplate,
    onRender: function () {
      this.$el.i18n();
      this.$el.find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]').tooltip({
        delay: { show: 333, hide: 0 },
        placement: "bottom",
      });
    },
    showProgressBar: function (refreshTime) {
      this.$el.find("#refreshProgressBar").animate({ width: 180 }, refreshTime, "linear");
    },
    triggers: {
      "click button": "refresh:kb",
    },
  });

  return KbRefreshMenuView;
});
